// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oP5q","content":"styles_content__3DkVg","tableWrap":"styles_tableWrap__3j9PC"};